import React from 'react';
import { withProviders } from '../../../contexts/main/withProviders';
import { ISinglePaymentPageProps } from './interfaces';
import { withChallengeData } from '../../../contexts/storage-contexts/Challenge';
import { withGeneralData } from '../../../contexts/GeneralDataProvider/withGeneralData';
import { withUser } from '../../../contexts/User/withUser';
import { withLocation } from '../../../contexts/Location/withLocation';

import { classes } from './Widget.st.css';
import { PaymentPageV1 } from './PaymentPageV1';
import { Spinner } from '@wix/wix-ui-tpa/dist/cssVars/esm/components/index.js';

export const PaymentPage = (props: ISinglePaymentPageProps) => {
  const { isForcedBlankPage = false } = props;

  if (isForcedBlankPage) {
    return (
      <div className={classes.loader}>
        <Spinner diameter={50} />
      </div>
    );
  }

  return <PaymentPageV1 {...props} />;
};

export default withProviders(
  withUser(withGeneralData(withLocation(withChallengeData(PaymentPage)))),
);
